import { ActionContainer } from '@/components/Event/NewScript/components/common/ScriptTimeline/ActionContainer'
import { ActionText } from '@/components/Event/NewScript/components/common/ScriptTimeline/ActionText'
import { ActionTitle } from '@/components/Event/NewScript/components/common/ScriptTimeline/ActionTitle'

/**
 * Stands in for the read/waive question where the jurisdiction decides.
 *
 * The step stays and is still confirmed: reporters are habituated to asking at
 * closing, and a row that simply vanishes gets asked anyway -- on the record,
 * in front of counsel, with nowhere to put the answer. Only the answer field
 * goes. Deliberately not `mono`, which is the script's convention for copy the
 * reporter reads aloud.
 */
export const ReadWaiveNotAskedNote = () => (
  <ActionContainer outer>
    <ActionContainer>
      <ActionTitle>Reminder</ActionTitle>
      <ActionText>
        Read or waive is not asked on this event. The jurisdiction&rsquo;s rule
        applies. Do not ask on the record.
      </ActionText>
    </ActionContainer>
  </ActionContainer>
)
